import * as React from "react";

import { Textarea } from "src/components/ui/textarea";
import { cn } from "src/lib/utils";
import { Field, type FieldProps } from "./Field";

export type TextAreaFieldProps = Omit<React.ComponentProps<"textarea">, "children"> &
	Pick<FieldProps, "label" | "error" | "hint"> & {
		containerClassName?: string;
	};

/** Multi-line input in the standard label/error frame. */
export const TextAreaField = React.forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(
	({ label, error, hint, required, name, containerClassName, className, ...props }, ref) => (
		<Field label={label} name={name} required={required} error={error} hint={hint} className={containerClassName}>
			<Textarea
				ref={ref}
				id={name}
				name={name}
				aria-invalid={!!error}
				className={cn(error && "tw-border-red focus-visible:tw-border-red focus-visible:tw-ring-red/20", className)}
				{...props}
			/>
		</Field>
	)
);
TextAreaField.displayName = "TextAreaField";

export default TextAreaField;
